import styled from 'styled-components'

import HeaderOriginal from 'components/Text/Header'
import LineInputOriginal from 'components/Inputs/LineInput'
import { colors } from 'themes'

export const Container = styled.div`
	background: ${colors.addOfficeLocation.background};
	color: ${colors.addOfficeLocation.text};
	border-radius: 16px;
	padding: 24px;
	
	display: flex;
	flex-direction: column;
	align-items: stretch;
	
	.info {	
		margin: 8px 0 15px;
	}
`

export const Header = styled(HeaderOriginal)`
	font-size: 1.5em;
`

const LineInput = styled(LineInputOriginal)`
	border: 3px solid ${colors.addOfficeLocation.inputBorder};
	::placeholder {
		color: ${colors.addOfficeLocation.placeholder};
		opacity: 0.5;
	}
`

export const InputRow = styled.div`
	margin-top: 14px;
	
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
`

export const StreetAddressInput = styled(LineInput)`

`

export const ProvinceInput = styled(LineInput)`
	flex: 0.56;
	margin-right: 6px;
`

export const ZipCodeInput = styled(LineInput)`
	flex: 0.44;
	margin-left: 6px;
`

export const UnitInput = styled(LineInput)`
	flex: 0.33;
	margin-right: 6px;
`

export const PhoneInput = styled(LineInput)`
	flex: 0.67;
	margin-left: 6px;
`

export const HorizontalSeparator = styled.div`
	margin: 27px 0 15px;
	border-top: 1px solid ${colors.addOfficeLocation.separator};
`
